import { render, staticRenderFns } from "./CardFooter.vue?vue&type=template&id=6c6119b1&scoped=true&"
import script from "./CardFooter.vue?vue&type=script&lang=js&"
export * from "./CardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6119b1",
  null
  
)

export default component.exports